require("./window.style.scss");
import { isUndefined } from 'angular'; 
export class WindowService {


    private $mdDialog: angular.material.IDialogService;
    private $translate: ng.translate.ITranslateService;
    public option: IWindowOption;
	public static $inject: Array<string> = ["$mdDialog", "$translate"];
	constructor($mdDialog: angular.material.IDialogService, $translate: ng.translate.ITranslateService) {
		this.$mdDialog = $mdDialog;
		this.$translate = $translate;
	}

    showSuccessWindow(opt: IWindowOption): void {
        this.option = opt;
        this.option.WindowType = WindowType.Success;
        this.option.Title = opt.Title || this.$translate.instant("HEADER.SUCCESS");
		this.showDialog();
	}

    showInfoWindow(opt: IWindowOption): void {
        this.option = opt;
        this.option.WindowType = WindowType.Information;
        this.option.Title = opt.Title || this.$translate.instant("HEADER.INFORMATION");
		this.showDialog();
	}

    showWarningWindow(opt: IWindowOption): void {
        this.option = opt;
        this.option.WindowType = WindowType.Warning;
        this.option.Title = opt.Title || this.$translate.instant("HEADER.WARNING");
		this.showDialog();
	}

    showErrorWindow(opt: IWindowOption): void {
        this.option = opt;
        this.option.WindowType = WindowType.Error;
        this.option.Title = opt.Title || this.$translate.instant("HEADER.ERROR");
		this.showDialog();
	}

    showConfirmWindow(opt: IWindowOption): void {
        this.option = opt;
        this.option.WindowType = WindowType.Confirm;
        this.option.Title = opt.Title || this.$translate.instant("BUTTON.CONFIRM");
		this.showDialog();
	}

    private showDialog(): void {
		this.$mdDialog.show({
			template: require('./window.html').default,
			multiple: true,
            escapeToClose: isUndefined(this.option.EscapeToClose) ? true : this.option.EscapeToClose,
			controllerAs: "vm",
			bindToController: true,
			locals: {
				modal: {
                    WindowType: this.option.WindowType,
                    TextContent: this.option.TextContent,
                    TextContentList: this.option.TextContentList,
                    Title: this.option.Title,
                    OkText: this.option.OkText || this.$translate.instant("BUTTON.OK"),
                    OkCallBack: this.option.OkCallBack,
                    CancelText: this.option.CancelText || this.$translate.instant("BUTTON.CANCEL"),
                    CancelCallBack: this.option.CancelCallBack
				}
			},
			controller: DialogController
		} as ng.material.IDialogOptions);
	}
}

class DialogController {

	public modal: IWindowOption;
	public $mdDialog: angular.material.IDialogService;

	public static $inject: Array<string> = [ "$mdDialog", "modal"];
	constructor($mdDialog: angular.material.IDialogService, modal: IWindowOption) {
		this.modal = modal;
		this.$mdDialog = $mdDialog;
	}

	OkClickFn() {
		this.$mdDialog.hide();

		if (typeof this.modal.OkCallBack === "function")
			this.modal.OkCallBack();
	}
	CancelClickFn() {
		this.$mdDialog.hide();

		if (typeof this.modal.CancelCallBack === "function")
			this.modal.CancelCallBack();
	}
}

export interface IWindowOption {

	ParentEl?: JQuery;
	Event?: MouseEvent;
	WindowType?: WindowType;
	EscapeToClose?: boolean;

	TextContent: string;
	TextContentList?: Array<string>,
	Title?: string,
	CancelText?: string;
	OkText?: string;

	OkCallBack?: Function,
	CancelCallBack?: Function,
}

export enum WindowType {
	Information = 0,
	Success = 1,
	Warning = 2,
	Error = 3,
	Confirm = 4
}